import {Localizer} from "../../../infrastructure/localization/localizer";

export enum VejledningDatoKategoriEnum {
    UnderEnMaaned = 1,
    OverEnMaaned = 2,
    OverTreMaaneder = 3,
    OverSeksMaaneder = 4,
    IkkeAfholdt = 5,
}

export function GetVejledningTimeString(status: VejledningDatoKategoriEnum): string {
    switch (status) {
        case VejledningDatoKategoriEnum.UnderEnMaaned:
            return Localizer.dashboard_underEnMaaned();
        case VejledningDatoKategoriEnum.OverEnMaaned:
            return Localizer.dashboard_overEnMaaned();
        case VejledningDatoKategoriEnum.OverSeksMaaneder:
            return Localizer.dashboard_overSeksMaaneder();
        case VejledningDatoKategoriEnum.IkkeAfholdt:
            return Localizer.dashboard_sletIkke();
        case VejledningDatoKategoriEnum.OverTreMaaneder:
            return Localizer.dashboard_overTreMaaneder();
        default:
            return "";
    }
}

export const getMinMaxDage = (value: VejledningDatoKategoriEnum): [number | undefined, number | undefined] => {
    switch (value) {
        case VejledningDatoKategoriEnum.UnderEnMaaned:
            return [0, 31];
        case VejledningDatoKategoriEnum.OverEnMaaned:
            return [30, undefined];
        case VejledningDatoKategoriEnum.OverTreMaaneder:
            return [92, undefined];
        case VejledningDatoKategoriEnum.OverSeksMaaneder:
            return [183, undefined];
        case VejledningDatoKategoriEnum.IkkeAfholdt:
            return [undefined, undefined];
        default:
            return [undefined, undefined];
    }
}

